import React from 'react'
import { Sale } from 'src/core/models'
import { useTranslation } from 'next-i18next'
import { useAppSelector } from 'src/app/hooks'
import { selectCurrencyToken } from 'src/features'
import { FormLabels } from 'src/components'
import { getFormatedPrice, getProjectUnitUd } from 'src/core/helpers'

const SaleAmountColumn: React.FC<{ sale: Sale }> = ({ sale }) => {
  const { t } = useTranslation()
  const currency_code = useAppSelector(selectCurrencyToken)

  return (
    <div className='centered-div'>
      <FormLabels
        title={getFormatedPrice(sale.supplierInvoiceTotalAmount || sale.amount, currency_code)}
        subtitle={`${sale.co2_amount} ${getProjectUnitUd(sale.projectKind, t, sale.co2_amount)}`}
      />
    </div>
  )
}

export default SaleAmountColumn
